import { render, staticRenderFns } from "./application-thank-you.vue?vue&type=template&id=dc39706e"
import script from "./application-thank-you.vue?vue&type=script&lang=js"
export * from "./application-thank-you.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports